// extracted by mini-css-extract-plugin
export default {"configRobot":"RobotCalendar_configRobot__p6jfZ"};